(function($) {

	'use strict';

	var SELECTORS = {
		content: '[data-slidebar-content]',
		sidebar: '[data-slidebar-nav]',
		button:  '[data-slidebar-button]'
	};

	var ICON_CLASSES = {
		open:  'fa-bars',
		close: 'fa-close'
	};

	var ATTRIBUTES = {
		class: 'slidebarClasses',
		open:  'slidebarOpen'
	};

	var $container = $('[data-slidebar-container]');

	function slidebar(index, container) {

		var isOpen    = false;
		var $elements = {};

		function updateElementClasses($element) {
			var classList = $element.data(ATTRIBUTES.class);
			// Add the new width and pull / push classes
			$element.attr('class', classList);
		}

		function open() {
			if(!isOpen) {
				$elements.wrapper.attr('data-slidebar-state', 'open');
				$elements.icon.addClass(ICON_CLASSES.close);
				$elements.icon.removeClass(ICON_CLASSES.open);
				isOpen = true;
			}
		}

		function close() {
			if(isOpen) {
				$elements.wrapper.attr('data-slidebar-state', 'closed');
				$elements.icon.addClass(ICON_CLASSES.open);
				$elements.icon.removeClass(ICON_CLASSES.close);
				isOpen = false;
			}
		}
		function handleButtonClick(e) {
			e.preventDefault();
			if(isOpen) {
				close();
			} else {
				open();
			}
		}

		function getElements() {
			$elements.wrapper = $(container);
			$elements.content = $elements.wrapper.children(SELECTORS.content);
			$elements.sidebar = $elements.wrapper.children(SELECTORS.sidebar);
			$elements.button  = $elements.wrapper.find(SELECTORS.button);
			$elements.icon    = $elements.button.children();
		}

		function init() {
			getElements();

			if($elements.content.length && $elements.sidebar.length && $elements.button.length) {
				updateElementClasses($elements.content);
				updateElementClasses($elements.sidebar);
				$elements.button.on('click', handleButtonClick);
			}
		}

		init();

	}

	if($container.length) {
		$container.each(slidebar);
	}

})($jq);
